import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MagazineData } from './magazine.model';
import { MagazineService } from './magazine.service';

export class MagazineDataSource implements DataSource<MagazineData> {

  private dataSubject = new BehaviorSubject<MagazineData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private magazineService: MagazineService) {}

  connect(collectionViewer: CollectionViewer): Observable<MagazineData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadMagazines(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'createdAt',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {
    this.loadingSubject.next(true);

    this.magazineService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.magazine);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
